const actions = {
    GET_ALL_PAYMENTS: "tariff/GET_ALL_PAYMENTS",
    SET_ALL_PAYMENTS: "tariff/SET_ALL_PAYMENTS",

    GET_PAYMENT_STATUSES: "tariff/GET_PAYMENT_STATUSES",
    SET_PAYMENT_STATUSES: "tariff/SET_PAYMENT_STATUSES",
};

export default actions;